<template>
  <div class="all">
    <div class="content">
      <img src="../../assets/img/title.png" class="title" />
      <header>
        <h4>
          {{ $t("valiform.welcome") }} <b>{{ $t("valiform.title") }}</b>
        </h4>
      </header>

      <main>
        <div v-if="form">
          <div>
            <vs-input v-model="value" :placeholder="$t('valiform.code')">
              <template #icon>
                <i class="bx bx-user"></i>
              </template>
              <template v-if="!value" #message-danger>
                {{ $t("valiform.required") }}
              </template>
            </vs-input>
            <vs-button class="valid" @click="validform">
              {{ $t("valiform.valid") }}
            </vs-button>
          </div>
        </div>
        <div v-else>
          <div class="show">
            <div class="fileinput">
              <vs-input
                primary
                readonly
                :label="$t('valiform.name')"
                v-model="name"
                state="primary"
                placeholder="Primary"
                disabled
              />
            </div>
            <div class="fileinput">
              <vs-input
                primary
                :label="$t('valiform.jobno')"
                v-model="jobno"
                state="primary"
                placeholder="Primary"
                disabled
              />
            </div>
            <div class="fileinput">
              <vs-input
                primary
                :label="$t('valiform.filename')"
                v-model="viewName"
                state="primary"
                placeholder="Primary"
                disabled
              />
            </div>
            <div class="fileinput">
              <vs-input
                primary
                :label="$t('valiform.creatime')"
                v-model="createtime"
                state="primary"
                placeholder="Primary"
                disabled
              />
            </div>
            <div class="fileinput">
              <vs-input
                primary
                :label="$t('valiform.secretcode')"
                v-model="value"
                state="primary"
                placeholder="Primary"
                disabled
              />
            </div>

            <vs-button-group>
              <vs-button block success icon @click="downloadfile">
                下载
                {{ $t("valiform.download") }}
              </vs-button>

              <vs-button block icon @click="seefile">
                <i class="bx bx-fullscreen"></i>
                {{ $t("valiform.see") }}
              </vs-button>
            </vs-button-group>
          </div>
        </div>
        <div class="center con-switch">
          <vs-switch color="#195bff" v-model="active2">
            <template #off> 中简 </template>
            <template #on> EN </template>
          </vs-switch>
        </div>
      </main>
    </div>
    <ValidDialog ref="validDialog"></ValidDialog>
    <a href="javascript:void(0);" id="oDownLoad" style="display:none;" >下载a</a>
  </div>
</template>

<script>
import { PrintQuery } from "@/api/data/view";
import ValidDialog from "./ValidDialog";
import { setLocale } from "@/language/index";
import Cookies from "js-cookie";
// import download from "downloadjs"
export default {
  components: {
    ValidDialog,
  },
  data() {
    return {
      form: true,
      name: "",
      value: "",
      jobno: "",
      createtime: "",
      viewName: "",
      enview: "",
      cnview: "",
      pdf: "",
      active2: "",
    };
  },
  async mounted() {
    console.log(this.$route, this.$router);
    const chooseLanguage = Cookies.get("language");
    if (chooseLanguage == "en") {
      this.active2 = true;
    }
    if (this.$route.query && this.$route.query.code) {
      this.value = this.$route.query.code;
      await this.validform();
    }
  },
  methods: {
    async validform() {
      if (this.value) {
        let res = await PrintQuery(this.value);
        console.log(res, "res");
        if (res && res.viewId) {
          this.form = false;
          this.jobno = res.jobno;
          this.name = res.name;
          this.enview = res.viewEnName;
          this.cnview = res.viewName;
          this.setname();
          var date = new Date(res.creationTime);
          date = new Date(date.setHours(date.getHours() + 8));
          this.pdf = "https://bddy.wmu.edu.cn/" + res.pdfpath + ".pdf";
          this.createtime = date
            .toISOString()
            .replace(/T/g, " ")
            .replace(/\.[\d]{3}Z/, "");
        }
      }
    },
    setname() {
      if (this.cnview) {
        if (Cookies.get("language") == "en") {
          this.viewName = this.enview==""?this.cnview:this.enview;
        } else {
          this.viewName = this.cnview;
        }
      }
    },
    async downloadFun(blobFile, fileName) {
      try{
        let blob = new Blob([blobFile], {
          type: "application/pdf;charset=UTF-8",
        })
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          let link = document.createElement("a")
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          window.URL.revokeObjectURL(link.href) //释放内存
        }
      }catch(error){
        alert(JSON.stringify(error));
      }
      
    },
    async downloadfile() {




      const u = navigator.userAgent;
      console.log(u, "u");
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      if (isAndroid) {
        // 安卓终端使用iframe
        window.open(this.pdf);
      } else if (isiOS) {
        
        var odownLoad=document.getElementById('oDownLoad');
            odownLoad.href= this.pdf;
            odownLoad.download="";
            odownLoad.click();


        // navigator.clipboard.writeText(this.pdf).then(
        //   () => {
        //     this.$vs.notification({
        //       color: "success",
        //       position: "top-center",
        //       title: this.$t("YJSProofOfReading.copysuccess"),
        //       text: this.$t("YJSProofOfReading.copysuccesstext"),
        //     });
        //   },
        //   (res) => {
        //     console.log(res);
        //     this.$vs.notification({
        //       color: "success",
        //       position: "top-center",
        //       title: this.$t("YJSProofOfReading.copyfail"),
        //       text: this.$t("YJSProofOfReading.copyfailtext") + this.pdf,
        //     });
        //   }
        // );
      } else {
        // 1.如果是地址
        window.open(this.pdf);
        //2.如果是文件流
      }
    },
    // async downloadFun(blobFile, fileName) {
    //   let blob = new Blob([blobFile], {
    //     type: "application/pdf;charset=UTF-8",
    //   });
    //   if (window.navigator.msSaveOrOpenBlob) {
    //     navigator.msSaveBlob(blob, fileName);
    //   } else {
    //     let link = document.createElement("a");
    //     link.href = window.URL.createObjectURL(blob);
    //     link.download = fileName;
    //     link.click();
    //     window.URL.revokeObjectURL(link.href); //释放内存
    //   }
    // },

    // downloadfile(){
    //   let form = document.getElementById('downloadForm')
    //   if (!form) {
    //     form = document.createElement('form')
    //     form.setAttribute('id', 'downloadForm')
    //     document.getElementsByTagName('body')[0].appendChild(form)
    //   }
    //   form.action = process.env.VUE_APP_BASE_API + "AuthorPdf?PrintId=" + this.value
    //   form.submit()
    //   // downdata(process.env.VUE_APP_BASE_API + "/AuthorPdf?PrintId=" + this.value,this.viewName);
    // },
    seefile() {
      this.$refs["validDialog"].dialog(this.value);
    },
  },
  watch: {
    active2(newvalue, oldvalue) {
      console.log(newvalue, oldvalue);
      if (newvalue == true || newvalue == null) {
        setLocale("en");
        Cookies.set("language", "en");
      } else {
        setLocale("zh-Hans");
        Cookies.set("language", "zh-Hans");
      }

      this.setname();
    },
  },
};
</script>

<style lang="scss" scoped>
.fileinput {
  padding: 10px 0;
}
.title {
  width: 60%;
  max-width: 300px;
}
body {
  overflow: hidden;
}
.all {
  width: 100%;
  height: 100vh;
  padding: 3rem 1rem;
  box-sizing: border-box;
  .content {
    border-radius: 20px;
    background: white;
    .valid {
      width: 100%;
      margin-top: 2rem;
    }
  }
}
header,
main {
  padding: 10px 28px;
  font-family: "宋体";
}
main {
  ::v-deep .vs-input-content {
    width: calc(100%);
    margin: 10px 0;
  }
  ::v-deep .vs-input {
    width: 100%;
  }
}
h4 {
  margin: 0;
  font-weight: 400;
  padding: 30px 10px 0;
  font-weight: 300 !important;
  line-height: 1.25;
}
.con-switch {
  margin-top: 20px;
  width: 60px;
}
</style>